exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "section[data-v-6e4f5342]{width:100vw;display:flex;max-width:100%;min-height:100vh;align-items:center;vertical-align:bottom;justify-content:center}.background[data-v-6e4f5342]{z-index:0;width:100%;min-height:100%;max-height:100vh;position:absolute}h1[data-v-6e4f5342]{margin:0;color:#ff3232;display:block;line-height:1;font-weight:300;text-align:center}img[data-v-6e4f5342]{width:42vw;max-height:20vh;min-width:340px;max-width:850px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6e4f5342","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?indentedSyntax!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./components/Hero.vue
// module id = 27
// module chunks = 0